angular.module('mtic.components.modules').service('MapStateService', function($log, EventManager) {
  var active_module = "";
  var active_items = [];
  var states = {};
  var focus_slug = "";
  var map_coords = {
    x : 0,
    y : 0
  };
  var selectedResourcesForAgendaCreation ={};
  var moduleModalsInvertedVisibility = {};
  var active_meta = "";
  var itemOptions;
  var next_item;
  var current_used_lang;
  var eventManager = new EventManager('MapStateService');
  return {
    reset: function(){
      active_module = "";
      active_items = [];
      states = {};
      focus_slug = "";
      active_meta = "";
      map_coords = {
        x : 0,
        y : 0
      };
      selectedResourcesForAgendaCreation ={};
      moduleModalsInvertedVisibility = {};
    },    
    getMetaStateSlug: function(){
      return active_meta
    },
    setMetaStateSlug: function(slug){
      active_meta = slug;
    },
    getActiveModule: function(){
      return active_module;
    },
    setActiveModule: function(slug){
      active_module = slug;
    },

    setItemState: function(slug, pos) {
      states[slug] = {
        x : pos.x,
        y : pos.y
      };
    },
    setFocusSlug: function(slug) {
      focus_slug = slug;
    },
    getFocusSlug: function() {
      return focus_slug;
    },
    getItemState: function(slug) {
      return states[slug];
    },
    getActiveItems : function() {
      return active_items;
    },
    setActiveItems : function(items) {
      active_items = items;
    },
    setMapCoords : function(x,y) {
      map_coords.x = x;
      map_coords.y = y;
    },
    getMapCoords : function() {
      return map_coords;
    },
    setModuleModalsInvertedVisibility : function(moduleName,isHidden){
      moduleModalsInvertedVisibility[moduleName] = isHidden;
    },
    getModuleModalsInvertedVisibility:function(moduleName){
      return moduleModalsInvertedVisibility[moduleName];
    },
    getSelectedResourcesForAgendaCreation:function(){
      return selectedResourcesForAgendaCreation;
    },
    setSelectedResourcesForAgendaCreation:function(resources){
      selectedResourcesForAgendaCreation = resources || {};
    },
    setItemOptions:function(options){
      $log.log('setItemOptions : ', options)
      itemOptions = options;
      eventManager.broadcast('set:lesson:options', options)
    },
    getItemOptions:function(){
      $log.log('getItemOptions : ', itemOptions)
      return itemOptions
    },
    setNextAvailableItem:function(item){
      next_item = item;
    },    
    getNextAvailableItem:function(){
      return next_item;
    },
    setCurrentItemLang:function(lang){
      current_used_lang = lang;
    },
    getCurrentItemLang:function(lang){
      return current_used_lang;
    }
  }
})
